import { Config } from "../core/config"



const no_acceso_pdf = () => {
    return /*html*/`
                    <div class="titulo insuficiente">
                        <h2> <strong>Tu cuenta no tiene acceso a la edición impresa en PDF.</strong></h2>
                    </div>
                    <br>
                    <div class="caja-mens">
                        <h4> <strong>Para acceder tendrás que actualizar tu suscripción.</strong> </h4>
                        <hr>
                        <p>
                            Para cambiarla comunicate al: <strong>(011) 5199-4787</strong> <br>
                            O desde el exterior a:  <br>
                            <a href="mailto:accesodigital@lanacion.com.ar">accesodigital@lanacion.com.ar</a>
                        </p>
                    </div>
                    `
}

const no_acceso_pdf_embed = () => {
    return /*html*/`
                    <div class="titulo insuficiente">
                        <h2> <strong>Tu cuenta no tiene acceso a la edición impresa en PDF.</strong></h2>
                    </div>
                    <br>
                    <div class="caja-mens">
                        <h4> <strong>Para acceder tendrás que actualizar tu suscripción.</strong> </h4>
                        <hr>
                        <p>
                            Para cambiarla comunicate al: <strong>(011) 5199-4787</strong> <br>
                            O desde el exterior a:  <br>
                            <a href="mailto:accesodigital@lanacion.com.ar">accesodigital@lanacion.com.ar</a>
                        </p>
                    </div>
                    `
}

module.exports = {
    no_acceso_pdf: no_acceso_pdf,
    no_acceso_pdf_embed: no_acceso_pdf_embed
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/pdf_suscripto_sin_acceso.js